const auth = {
    title: {
        login: 'Login',
        forgot: 'Forgot your password?',
        register: 'No account? Create one',
        registerCode: 'Confirm your email',
        password: 'Setup your password!',
    },
    helper: {
        registerCode: 'Enter the code your received on your email.',
        password:
            'The password must contain at least 8 characters with at least 1 uppercase letter, 1 lowercase letter and 1 number',
        forgot: 'Forgot your passowrd?',
    },
    login: {
        fields: {
            name: 'My name',
            email: 'My email',
            password: 'My password',
            newPassword: 'My new password',
            confirmPassword: 'Confirm your password',
        },
        label: {
            password: 'password',
        },
        message: {
            success: 'You are logged!',
            error: 'Same gamer play again!',
        },
        helpers: {
            name: 'enter your name',
            email: 'enter your email',
            password: 'enter your password',
        },
        buttons: {
            register: 'Create my account',
            continue: 'Continue',
            submit: 'Login',
            back: 'Back to login',
            newCode: "I didn't received the code",
        },
    },
    register: {
        success: 'You account was created successfully!',
        error: "You account wasn't created successfully!",
        titleHelper:
            'The password must contain at least 8 characters with at least 1 uppercase letter, 1 lowercase letter and 1 number',
        passwordValidation: 'The password is not valid',
        matchError: 'Password not match',
    },
    forgot: {
        success: 'Your password was successfully updated!',
        error: "Your password wasn't updated, try again!",
    },
}

export default auth
